import React, {Component} from 'react';
import {connect} from 'react-redux';
import {TeamComponent} from '../team';
import {Factory as TeamDetailsFactory} from '../team/team-details/factory';
import {parseGameInfo} from 'helpers/game-helper';

class GameTeams extends Component {
    getTeamNames() {
        const {game} = this.props;

        return parseGameInfo(game.gameInfo);
    }
    render() {
        const {game, sportConfig, clickOnTeamCallback} = this.props;
        const content = [];
        const TeamDetails = TeamDetailsFactory.getComponent(sportConfig);

        this.getTeamNames().forEach((teamName, index) => {
            content.push(
                <TeamComponent
                    key={index}
                    isLeftSide={!index}
                    teamName={teamName}
                    clickOnTeamCallback={clickOnTeamCallback}
                    className={'filter-players-games'}
                >
                    <TeamDetails game={game} teamName={teamName} />
                </TeamComponent>,
            );
        });

        return (
            <div className="filter-box-top">
                {content}
                <span className="vs-text">@</span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(GameTeams);
